// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header__sectionSmall___SsvIi {
}

.header__row___q6yBO {
}

.header__ticketFlag___aAaAm {
  display: inline-block;
  height: 25px;
  margin: 0;
  padding: 0;
}

.header__ticketFlag___aAaAm img {
    height: 25px;
    margin-right: 5px;
  }

.header__boxLabel___xZnwO {
  line-height: 26px;
  margin: 0;
}

.header__accountBoxLabel___NBtEh {
  font-weight: 700;
  text-transform: uppercase;
}

.header__accountStatusCaption___KiBLL {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  opacity: 0.75;
  font-size: 11px;
}

.header__headerLight___gHl8s {
  margin-top: 5px;
  color: #7d7d7d;
}

.header__headerLight___gHl8s h4 {
    margin-top: 3px;
    font-weight: 400;
  }

.header__nameWrapper___JqsH9 {
  width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
  padding: 16px;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
}

.header__nameWrapper___JqsH9:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.header__nameWrapper___JqsH9:last-child {
  margin-right: 0;
}

.header__nameWrapper___JqsH9:nth-child(1n) {
  margin-right: 0;
  float: right;
}

.header__nameWrapper___JqsH9:nth-child(1n + 1) {
  clear: both;
}

.header__nameWrapper___JqsH9 .header__boxLabel___xZnwO {
    margin-right: 20px;
  }

.header__accountRef___uRGEe {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
  position: fixed;
  right: 0;
  top: 120px;
}

.header__accountRef___uRGEe:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.header__accountRef___uRGEe:last-child {
  margin-right: 0;
}

.header__accountRef___uRGEe:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.header__accountRef___uRGEe:nth-child(3n + 1) {
  clear: both;
}

.header__beneName___YxRQ8 {
  box-shadow: none;
  color: text;
}
.header__redirectIcon___a1utw {
  margin: 0 -10px 0 0 !important;
  box-shadow: none;
}
.header__redirectIcon___a1utw:hover {
    box-shadow: none !important;
  }

.header__balanceWrapper___GxUx6 {
  width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
}

.header__balanceWrapper___GxUx6:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.header__balanceWrapper___GxUx6:last-child {
  margin-right: 0;
}

.header__balanceWrapper___GxUx6:nth-child(1n) {
  margin-right: 0;
  float: right;
}

.header__balanceWrapper___GxUx6:nth-child(1n + 1) {
  clear: both;
}

.header__accountStatusWrapper___jWbjb {
  width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.5px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
}

.header__accountStatusWrapper___jWbjb:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.header__accountStatusWrapper___jWbjb:last-child {
  margin-right: 0;
}

.header__accountStatusWrapper___jWbjb:nth-child(1n) {
  margin-right: 0;
  float: right;
}

.header__accountStatusWrapper___jWbjb:nth-child(1n + 1) {
  clear: both;
}

.header__standardHeight___Er5ek {
  min-height: 100px;
}

.header__trusts___Gg0F8 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -5px;
  width: 100%;
}
.header__trustsHeader___IWKPg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
}
.header__trusts___Gg0F8 a {
  margin: 0 10px 0 0;
}

.header__trustsItem___ARHXA {
  margin: 0 10px;
  display: inline-block;
  vertical-align: middle;
}

.header__titleBox___YLlO3 {
  position: relative;
  height: calc(100vh - 123px);
  display: flex;
  justify-content: center;
  align-items: baseline;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.887);
}
.header__titleHeaderHeight___eVh6_ {
  height: calc(100vh - 65px) !important;
}

.header__titleBoxRow___vbMx6 {
  width: 100%;
  padding-bottom: 12px;
}

.header__titleName___K9S5C {
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
}

.header__accountNumberLine___LZg_C {
  display: flex;
  align-items: center;
  justify-content: left;
  margin-top: 8px;
}

.header__accountNumber___XXrmW {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  padding: 2px 4px;
  vertical-align: middle;
}

.header__closedStatus___sRuN3 {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 10px;
  padding: 2px 4px;
  vertical-align: middle;
}

.header__closingStatus___Hi8Tl {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 10px;
  padding: 2px 4px;
  vertical-align: middle;
}

.header__deceasedFlag___Sk0H6 {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  float: left;
  margin-bottom: 5px;
  margin-left: 10px;
  padding: 2px 4px;
  vertical-align: middle;
}

.header__trustName___JnZLZ {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
}

.header__accountBoxStatus___dYOqh {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  text-align: right;
}

.header__accountBoxStatus___dYOqh:before {
  content: '';
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 5px 5px 0 0;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  border-radius: 100%;
}

.header__productDescription___tjS8c {
  margin-top: 8px;
}

.header__accountStatusOption___csx9k {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  font-size: 1rem;
  margin-left: 30px;
}

.header__accountStatusOption___csx9k:before {
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  margin-right: 10px;
  content: '\\2713';
  color: white;
  padding: 1px 3px;
  font-size: 12px;
}

.header__sectionHeader___USnvO {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]} !important;
  border-bottom: 1px solid rgba(73, 80, 84, 0.15);
  border-radius: 4px 4px 0 0 !important;
}

.header__sectionHeader___USnvO h5 {
    border-radius: 4px 4px 0 0 !important;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]} !important;
    padding: 20px 16px;
  }

.header__sectionHeader___USnvO span {
    padding-right: 16px;
  }

.header__subAccount___PNqvD {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  opacity: 0.6;
}

.header__rowHeader___NUTNn {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.header__singleLine___sU4f5 {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.header__singleLine___sU4f5:not(:last-child) {
    border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]};
  }
.header__singleLine___sU4f5 div.header__label___Q0Jft {
    font-size: 14px;
    color: text;
    opacity: 0.9;
  }
.header__rowError___UK0Gf {
}
.header__rowError___UK0Gf .header__value___FK6XW,
  .header__rowError___UK0Gf .header__label___Q0Jft {
    color: gtRed;
  }
.header__rowError___UK0Gf .header__error___nAcru {
    font-weight: bold;
  }

.header__valueMono___V1Rwa {
  font-family: MaisonMono, monospace;
}

.header__valueBlank___fR94n {
  color: #eee;
}

.header__valueBold___x7IkD {
  color: gtBlueDark;
  font-weight: bold;
}

.header__valueAlert___EtKL3 {
  color: gtRed;
  font-weight: bold;
}
.header__childrenItems___fRDZj {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./universal/components/References/header.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;AAEA;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,UAAU;AAMZ;;AAJE;IACE,YAAY;IACZ,iBAAiB;EACnB;;AAGF;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mDAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAMhB;;AAJE;IACE,eAAe;IACf,gBAAgB;EAClB;;AAGF;EACE,8CAAgB;EAChB,aAAa;EACb,qEAA+B;AAKjC;;AARA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAOlB;;AARA;EACE,eAAgB;AAOlB;;AARA;EACE,eAAgB;EAAhB,YAAgB;AAOlB;;AARA;EACE,WAAgB;AAOlB;;AAHE;IACE,kBAAkB;EACpB;;AAGF;EACE,8CAAgB;EAChB,eAAe;EACf,QAAQ;EACR,UAAU;AACZ;;AALA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAIlB;;AALA;EACE,eAAgB;AAIlB;;AALA;EACE,eAAgB;EAAhB,YAAgB;AAIlB;;AALA;EACE,WAAgB;AAIlB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAIlB;AAHE;IACE,2BAA2B;EAC7B;;AAGF;EACE,8CAAgB;EAChB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qEAA+B;AACjC;;AAPA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAMlB;;AAPA;EACE,eAAgB;AAMlB;;AAPA;EACE,eAAgB;EAAhB,YAAgB;AAMlB;;AAPA;EACE,WAAgB;AAMlB;;AAEA;EACE,8CAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uEAAiC;AACnC;;AAPA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAMlB;;AAPA;EACE,eAAgB;AAMlB;;AAPA;EACE,eAAgB;EAAhB,YAAgB;AAMlB;;AAPA;EACE,WAAgB;AAMlB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,wDAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mDAAa;AACf;;AAEA;EACE,mDAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8DAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8DAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0EAA2C;EAC3C,+CAA+C;EAC/C,qCAAqC;AAUvC;;AARE;IACE,qCAAqC;IACrC,0EAA2C;IAC3C,kBAAkB;EACpB;;AACA;IACE,mBAAmB;EACrB;;AAGF;EACE,mDAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAWhC;AATE;IACE,qEAAyC;EAC3C;AAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;AAEF;AAWA;AARE;;IAEE,YAAY;EACd;AAEA;IACE,iBAAiB;EACnB;;AAGF;EAEE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AAEb;;AAEA;EACE,iBAAiB;EAEjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EAEZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,YAAY;AACd","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: 'styles/colors.css';\n@value gtGPT, gtBlue, gtRedDark, gtYellowDark,borderColorLight, textLight, gtGreen, gtGray, gtGrayLight, gtGrayDark, gtCardHeaderBG from colors;\n\n.sectionSmall {\n  composes: sectionSmall from helpers;\n}\n\n.row {\n  composes: row from helpers;\n}\n\n.ticketFlag {\n  display: inline-block;\n  height: 25px;\n  margin: 0;\n  padding: 0;\n\n  & img {\n    height: 25px;\n    margin-right: 5px;\n  }\n}\n\n.boxLabel {\n  line-height: 26px;\n  margin: 0;\n}\n\n.accountBoxLabel {\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.accountStatusCaption {\n  color: gtGrayDark;\n  opacity: 0.75;\n  font-size: 11px;\n}\n\n.headerLight {\n  margin-top: 5px;\n  color: #7d7d7d;\n\n  & h4 {\n    margin-top: 3px;\n    font-weight: 400;\n  }\n}\n\n.nameWrapper {\n  lost-column: 1/1;\n  padding: 16px;\n  border-bottom: 1px solid gtGray;\n\n  .boxLabel {\n    margin-right: 20px;\n  }\n}\n\n.accountRef {\n  lost-column: 1/3;\n  position: fixed;\n  right: 0;\n  top: 120px;\n}\n\n.beneName {\n  box-shadow: none;\n  color: text;\n}\n.redirectIcon {\n  margin: 0 -10px 0 0 !important;\n  box-shadow: none;\n  &:hover {\n    box-shadow: none !important;\n  }\n}\n\n.balanceWrapper {\n  lost-column: 1/1;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid gtGray;\n}\n\n.accountStatusWrapper {\n  lost-column: 1/1;\n  padding: 0 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 0.5px solid gtGray;\n}\n\n.standardHeight {\n  min-height: 100px;\n}\n\n.trusts {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -5px;\n  width: 100%;\n}\n.trustsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  cursor: pointer;\n}\n.trusts a {\n  margin: 0 10px 0 0;\n}\n\n.trustsItem {\n  margin: 0 10px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.titleBox {\n  composes: sectionSmall row;\n  position: relative;\n  height: calc(100vh - 123px);\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  overflow-y: auto;\n  background-color: rgba(255, 255, 255, 0.887);\n}\n.titleHeaderHeight {\n  height: calc(100vh - 65px) !important;\n}\n\n.titleBoxRow {\n  width: 100%;\n  padding-bottom: 12px;\n}\n\n.titleName {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 5px;\n}\n\n.accountNumberLine {\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  margin-top: 8px;\n}\n\n.accountNumber {\n  background: gtGPT;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.closedStatus {\n  background: gtRedDark;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-left: 10px;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.closingStatus {\n  background: gtYellowDark;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-left: 10px;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.deceasedFlag {\n  background: gtRedDark;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  float: left;\n  margin-bottom: 5px;\n  margin-left: 10px;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.trustName {\n  color: gtBlue;\n}\n\n.accountBoxStatus {\n  color: gtGreen;\n  text-align: right;\n}\n\n.accountBoxStatus:before {\n  content: '';\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin: 5px 5px 0 0;\n  background-color: gtGreen;\n  border-radius: 100%;\n}\n\n.productDescription {\n  margin-top: 8px;\n}\n\n.accountStatusOption {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 0;\n  font-size: 1rem;\n  margin-left: 30px;\n}\n\n.accountStatusOption:before {\n  content: '';\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  background-color: gtGreen;\n  margin-right: 10px;\n  content: '\\2713';\n  color: white;\n  padding: 1px 3px;\n  font-size: 12px;\n}\n\n.sectionHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: gtCardHeaderBG !important;\n  border-bottom: 1px solid rgba(73, 80, 84, 0.15);\n  border-radius: 4px 4px 0 0 !important;\n\n  h5 {\n    border-radius: 4px 4px 0 0 !important;\n    background-color: gtCardHeaderBG !important;\n    padding: 20px 16px;\n  }\n  span {\n    padding-right: 16px;\n  }\n}\n\n.subAccount {\n  color: gtGrayDark;\n  opacity: 0.6;\n}\n\n.rowHeader {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n}\n.singleLine {\n  display: flex;\n  width: 100%;\n  height: 40px;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid borderColorLight;\n  }\n\n  div.label {\n    font-size: 14px;\n    color: text;\n    opacity: 0.9;\n  }\n}\n.rowError {\n  composes: row;\n\n  .value,\n  .label {\n    color: gtRed;\n  }\n\n  .error {\n    font-weight: bold;\n  }\n}\n\n.valueMono {\n  composes: value;\n  font-family: MaisonMono, monospace;\n}\n\n.valueBlank {\n  color: #eee;\n  composes: value;\n}\n\n.valueBold {\n  color: gtBlueDark;\n  composes: value;\n  font-weight: bold;\n}\n\n.valueAlert {\n  color: gtRed;\n  composes: value;\n  font-weight: bold;\n}\n.childrenItems {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: flex-start;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `'styles/colors.css'`,
	"gtGPT": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtRedDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"borderColorLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"sectionSmall": `header__sectionSmall___SsvIi ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"row": `header__row___q6yBO ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"ticketFlag": `header__ticketFlag___aAaAm`,
	"boxLabel": `header__boxLabel___xZnwO`,
	"accountBoxLabel": `header__accountBoxLabel___NBtEh`,
	"accountStatusCaption": `header__accountStatusCaption___KiBLL`,
	"headerLight": `header__headerLight___gHl8s`,
	"nameWrapper": `header__nameWrapper___JqsH9`,
	"accountRef": `header__accountRef___uRGEe`,
	"beneName": `header__beneName___YxRQ8`,
	"redirectIcon": `header__redirectIcon___a1utw`,
	"balanceWrapper": `header__balanceWrapper___GxUx6`,
	"accountStatusWrapper": `header__accountStatusWrapper___jWbjb`,
	"standardHeight": `header__standardHeight___Er5ek`,
	"trusts": `header__trusts___Gg0F8`,
	"trustsHeader": `header__trustsHeader___IWKPg`,
	"trustsItem": `header__trustsItem___ARHXA`,
	"titleBox": `header__titleBox___YLlO3 header__sectionSmall___SsvIi ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]} header__row___q6yBO ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"titleHeaderHeight": `header__titleHeaderHeight___eVh6_`,
	"titleBoxRow": `header__titleBoxRow___vbMx6`,
	"titleName": `header__titleName___K9S5C`,
	"accountNumberLine": `header__accountNumberLine___LZg_C`,
	"accountNumber": `header__accountNumber___XXrmW`,
	"closedStatus": `header__closedStatus___sRuN3`,
	"closingStatus": `header__closingStatus___Hi8Tl`,
	"deceasedFlag": `header__deceasedFlag___Sk0H6`,
	"trustName": `header__trustName___JnZLZ`,
	"accountBoxStatus": `header__accountBoxStatus___dYOqh`,
	"productDescription": `header__productDescription___tjS8c`,
	"accountStatusOption": `header__accountStatusOption___csx9k`,
	"sectionHeader": `header__sectionHeader___USnvO`,
	"subAccount": `header__subAccount___PNqvD`,
	"rowHeader": `header__rowHeader___NUTNn`,
	"singleLine": `header__singleLine___sU4f5`,
	"label": `header__label___Q0Jft`,
	"rowError": `header__rowError___UK0Gf header__row___q6yBO ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"value": `header__value___FK6XW`,
	"error": `header__error___nAcru`,
	"valueMono": `header__valueMono___V1Rwa header__value___FK6XW`,
	"valueBlank": `header__valueBlank___fR94n header__value___FK6XW`,
	"valueBold": `header__valueBold___x7IkD header__value___FK6XW`,
	"valueAlert": `header__valueAlert___EtKL3 header__value___FK6XW`,
	"childrenItems": `header__childrenItems___fRDZj`
};
export default ___CSS_LOADER_EXPORT___;
